// extracted by mini-css-extract-plugin
module.exports = {"ul":"_1GXMOxXhrKaE7as4XFgxJU","li":"_2rzEGD3xudls529GfW1OsO","link":"qD4l56_BRrn9Lla9aK_Ye"};